import {
    CURRENT_CHAMBER_UPDATE,
} from "../lib/types";
import { createSelector } from "reselect";
import store from "../store";

const initialState = {
    currentColumn: 0,
    currentRow: 0,
    numberRows: 0,
    numOfChambersPerRow: 0,
    currentChamber: null
};

export let currentSelectedChamberReducer = ( state = initialState, action ) => {
    switch (action.type) {
        case CURRENT_CHAMBER_UPDATE:
            return {
                currentColumn: action.payload.col,
                currentRow: action.payload.row,
                numberRows: action.payload.chamberbed.numOfRows,
                numOfChambersPerRow: action.payload.chamberbed.numOfChambers,
                currentChamber: action.payload.chamberbed.chamberRows[action.payload.row]._chambers[action.payload.col],
            };

        default:
            return state;
    }
};

// SELECTORS
const getCurrentSelectedChamberData = state => state.currentSelectedChamber;
const getChamberBed = state => state.chamberbed;
const getChamberType = state => state.globals.chamberType;

const CurrentSelectedChamberSelectors = {
    getCurrentChambersInfo: () => {
        const currentChambersInfo = createSelector(
            [
                getCurrentSelectedChamberData,
                getChamberBed,
                getChamberType
            ],
            (
                currentSelectedChamberData,
                chamberBed,
                chamberType
            ) => {

                const numberOfUpperChambersRows = 1;

                let leftChambersData = [];
                let rightChambersData = [];
                let upperChambersData = [];
                let lowerChambersData = [];

                const chamberRow = chamberBed.chamberRows[currentSelectedChamberData.currentRow];
                const firstActiveChamber = chamberRow.getFirstActiveChamber();
                const lastActiveChamber = chamberRow.getLastActiveChamber();
                const isFirstActiveChamber = firstActiveChamber &&
                    firstActiveChamber.col === currentSelectedChamberData.currentColumn;
                const isLastActiveChamber = lastActiveChamber &&
                    lastActiveChamber.col === currentSelectedChamberData.currentColumn;

                const isInnerChamber = !isFirstActiveChamber &&
                    !isLastActiveChamber;

                const currentChamberMetadata = {
                    currentSelectedChamber: {
                        row: currentSelectedChamberData.currentRow,
                        chamberNumber: currentSelectedChamberData.currentColumn,
                        active: currentSelectedChamberData.currentChamber.active,
                        upperCapActive: currentSelectedChamberData.currentChamber.upperCapActive,
                        lowerCapActive: currentSelectedChamberData.currentChamber.lowerCapActive,
                        isInnerChamber: isInnerChamber,
                        isFirstActiveChamber: isFirstActiveChamber,
                        isLastActiveChamber: isLastActiveChamber,
                        chamberType: {
                            id: chamberType.id,
                            type: chamberType.type
                        }
                    },
                    chamberBed: {
                        totalRows: currentSelectedChamberData.numberRows,
                        numberOfChambers: currentSelectedChamberData.numOfChambersPerRow
                    }
                }
                let pointerRow = currentSelectedChamberData.currentRow + 1;
                // Adds right side chambers from the selected chamber
                try {
                    let leftRemaining = currentSelectedChamberData.numberRows;
                    while (pointerRow < leftRemaining) {
                        pointerRow++;
                        const chamber = {
                            row: pointerRow - 1,
                            chamberNumber: currentSelectedChamberData.currentColumn,
                            active: chamberBed.chamberRows[pointerRow - 1]
                                .chambers[currentSelectedChamberData.currentColumn].active,
                            upperCapActive: chamberBed.chamberRows[pointerRow - 1]
                                .chambers[currentSelectedChamberData.currentColumn].upperCapActive,
                            lowerCapActive: chamberBed.chamberRows[pointerRow - 1]
                                .chambers[currentSelectedChamberData.currentColumn].lowerCapActive
                        }
                        leftChambersData.push(chamber)
                    }
                } catch (e) {

                }

                pointerRow = currentSelectedChamberData.currentRow;
                // Adds right side chambers from the selected chamber
                try {
                    while (pointerRow > 0) {
                        pointerRow--;
                        const chamber = {
                            row: pointerRow,
                            chamberNumber: currentSelectedChamberData.currentColumn,
                            active: chamberBed.chamberRows[pointerRow]
                                .chambers[currentSelectedChamberData.currentColumn].active,
                            upperCapActive: chamberBed.chamberRows[pointerRow]
                                .chambers[currentSelectedChamberData.currentColumn].upperCapActive,
                            lowerCapActive: chamberBed.chamberRows[pointerRow]
                                .chambers[currentSelectedChamberData.currentColumn].lowerCapActive
                        }
                        rightChambersData.push(chamber)
                    }
                } catch (e) {
                }

                // Adds upper chambers row if chamber is not external and upper

                try {
                    if (currentSelectedChamberData.currentColumn >= 1) {
                        pointerRow = currentSelectedChamberData.numberRows;
                        while (pointerRow > 0) {
                            pointerRow--;
                            const chamber = {
                                row: pointerRow,
                                chamberNumber: currentSelectedChamberData.currentColumn - 1,
                                active: chamberBed.chamberRows[pointerRow]
                                    .chambers[currentSelectedChamberData.currentColumn - numberOfUpperChambersRows].active,
                                upperCapActive: chamberBed.chamberRows[pointerRow]
                                    .chambers[currentSelectedChamberData.currentColumn - numberOfUpperChambersRows].upperCapActive,
                                lowerCapActive: chamberBed.chamberRows[pointerRow]
                                    .chambers[currentSelectedChamberData.currentColumn - numberOfUpperChambersRows].lowerCapActive
                            }
                            upperChambersData.push(chamber)
                        }
                    }
                } catch (e) {

                }

                // Adds lower chambers row if chamber is not external and lower
                try {
                    if (currentSelectedChamberData.currentColumn < currentSelectedChamberData.numOfChambersPerRow - 1) {
                        pointerRow = currentSelectedChamberData.numberRows;
                        while (pointerRow > 0) {
                            pointerRow--;
                            const chamber = {
                                row: pointerRow,
                                chamberNumber: currentSelectedChamberData.currentColumn + 1,
                                active: chamberBed.chamberRows[pointerRow]
                                    ._chambers[currentSelectedChamberData.currentColumn + numberOfUpperChambersRows].active,
                                upperCapActive: chamberBed.chamberRows[pointerRow]
                                    ._chambers[currentSelectedChamberData.currentColumn + numberOfUpperChambersRows].upperCapActive,
                                lowerCapActive: chamberBed.chamberRows[pointerRow]
                                    ._chambers[currentSelectedChamberData.currentColumn + numberOfUpperChambersRows].lowerCapActive
                            }
                            lowerChambersData.push(chamber)
                        }
                    }
                } catch (e) {

                }
                return {...currentChamberMetadata, leftChambersData, rightChambersData, upperChambersData, lowerChambersData};
            });
        return currentChambersInfo(store.getState());
    },

    getChamberByPosition: ( row, column ) => {
        const currentChambersInfo = createSelector(
            [
                getCurrentSelectedChamberData,
                getChamberBed
            ],
            (
                currentSelectedChamberData,
                chamberBed
            ) => {
                try {
                    return chamberBed.chamberRows[row]._chambers[column];
                } catch (e) {
                    return null;
                }
            });
        return currentChambersInfo(store.getState());
    },

    /*getCurrentChamber: () => {
        const currentChambers = createSelector(
            [
                getCurrentSelectedChamber
            ],
            (
                currentSelectedChamber,
            ) => {
                return currentSelectedChamber;
            });
        return currentChambers(store.getState());
    },*/

    isManifoldAttachedToChamber( row, column ) {
        const currentChambersInfo = createSelector(
            [
                getCurrentSelectedChamberData,
                getChamberBed,
            ],
            (
                currentSelectedChamberData,
                chamberBed,
            ) => {
                try {
                    return chamberBed.chamberRows[row]._chambers[column]._isManifoldConnectedArray.length > 0;
                } catch (e) {
                    return false;
                }
            });
        return currentChambersInfo(store.getState());
    },

    isOppositeStubAttachedToChamber( row, column ) {

        const currentChambersInfo = createSelector(
            [
                getCurrentSelectedChamberData,
                getChamberBed,
            ],
            (
                currentSelectedChamberData,
                chamberBed,
            ) => {
                try {
                    return chamberBed.chamberRows[row]._chambers[column]._isOppositeStubAttached;
                } catch (e) {
                    return false;
                }
            });
        return currentChambersInfo(store.getState());

    },

    /**
     * Test if its active
     * @param row
     * @param column
     * @returns {unknown}
     */
    isTestedChamberActive( row, column ) {
        const currentChambersInfo = createSelector(
            [
                getCurrentSelectedChamberData,
                getChamberBed,
            ],
            (
                currentSelectedChamberData,
                chamberBed,
            ) => {
                try {
                    return chamberBed.chamberRows[row]._chambers[column]._active;
                } catch (e) {
                    return false;
                }
            });
        return currentChambersInfo(store.getState());
    },

    hasChamberTee( row, column ) {
        const currentChambersInfo = createSelector(
            [
                getCurrentSelectedChamberData,
                getChamberBed,
            ],
            (
                currentSelectedChamberData,
                chamberBed,
            ) => {
                try {
                    return chamberBed.chamberRows[row]._chambers[column]._accessory.id === "Inserta-tee";
                } catch (e) {
                    return false;
                }
            });
        return currentChambersInfo(store.getState());
    },

    hasChamberInspectionPort( row, column ) {
        const currentChambersInfo = createSelector(
            [
                getCurrentSelectedChamberData,
                getChamberBed,
            ],
            (
                currentSelectedChamberData,
                chamberBed,
            ) => {
                try {
                    return chamberBed.chamberRows[row]._chambers[column]._accessory.id === "Inspection-port";
                } catch (e) {
                    return false;
                }
            });
        return currentChambersInfo(store.getState());
    },

}

export default CurrentSelectedChamberSelectors;



// WEBPACK FOOTER //
// ./src/reducers/current-selected-chamber-reducer.js